import React from 'react';
import { Country, PerLanguageConfig } from '../../domain/country/type';

export type LocaleContextType = {
  country: Country;
  configs: PerLanguageConfig;
};

export const context = React.createContext<LocaleContextType | undefined>(
  undefined,
);

export const useLocaleContext = (): LocaleContextType => {
  const contextValue = React.useContext(context);
  if (!contextValue) {
    console.trace('failure in useLocaleContext');
    throw new Error('useLocaleContext must be used within a LocaleProvider');
  }
  return contextValue;
};
